import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState
} from 'react'
import { AccountDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { isUserOutOfTierBasedOnLandline } from 'utils/tier'
import { withObservables } from '@nozbe/watermelondb/react'
import ObserveService from 'services/db/Observe'
import { OutOfTierDialog } from 'components/tier/OutOfTierDialog'

interface LandlineCheckProviderProps {
  children: ReactNode
  account: Model<AccountDoc>
}
function LandlineCheckProvider(props: LandlineCheckProviderProps) {
  const [showOutOfTierBasedOnLandline, onShowOutOfTierBasedOnLandline] =
    useState(isUserOutOfTierBasedOnLandline(props.account))

  const [context, setContext] = useState<LandlineCheckContextProps>({
    outOfTierBasedOnLandline: showOutOfTierBasedOnLandline,
    onShowOutOfTierBasedOnLandline
  })

  useEffect(() => {
    onShowOutOfTierBasedOnLandline(
      isUserOutOfTierBasedOnLandline(props.account)
    )
  }, [props.account])

  return (
    <LandlineCheckContext.Provider value={context}>
      {props.children}
      {showOutOfTierBasedOnLandline && (
        <OutOfTierDialog
          setOpen={onShowOutOfTierBasedOnLandline}
          opened={showOutOfTierBasedOnLandline}
          account={props.account}
        />
      )}
    </LandlineCheckContext.Provider>
  )
}

interface LandlineCheckContextProps {
  outOfTierBasedOnLandline: boolean
  onShowOutOfTierBasedOnLandline: (b: boolean) => void
}

const LandlineCheckContext = createContext<LandlineCheckContextProps>({
  outOfTierBasedOnLandline: false,
  onShowOutOfTierBasedOnLandline: (b: boolean) => {}
})

const LandlineCheckProviderrWithAccount = withObservables([], () => ({
  account: ObserveService.Account()
}))(LandlineCheckProvider)

function useLandlineCheck(): LandlineCheckContextProps {
  return useContext(LandlineCheckContext)
}

export {
  LandlineCheckProviderrWithAccount as LandlineCheckProvider,
  useLandlineCheck
}
